import React from 'react';
import moment from 'moment';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data, onDelete, onEdit}) => {
    const rows = [
        ...(data.feedRates || []).map(element => ({
            label: element.materialName,
            value: element.feedRate,
        })),
    ];

    const menuItems = [
        onEdit && { label: 'Edit', onClick: onEdit },
        onDelete && { label: 'Delete', onClick: onDelete },
    ].filter(Boolean);

    return (
        <PPMobileCardView
            title={moment(data.date).format("DD/MM/YYYY")}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
